import{ gsap }from"gsap/dist/gsap";

export default function initItSlider(){
    const sliders = document.querySelectorAll(".it-slider");

    sliders.forEach(slider => {
        const contentSlides = slider.querySelectorAll(".it-slider__right__detail__content__item");

        let tallest = 0;
        contentSlides.forEach(contentSlide => {
            const height = contentSlide.getBoundingClientRect().height;
            if(height > tallest){
                tallest = height;
            }
        });

        contentSlides[0].parentElement.style.height = tallest + "px";

        const slideCount = contentSlides.length;
        const pag = slider.querySelector(".it-slider__right__detail__pag__count");
        if(pag){
            pag.innerHTML = (slideCount < 10 ? `0${slideCount}` : `${slideCount}`);
        }

        const leftArrow = slider.querySelector(".it-slider__right__detail__controls__arrow--left");
        leftArrow?.addEventListener("click", function (){
            switchSlide(slider, -1, leftArrow, rightArrow);
        });

        const rightArrow = slider.querySelector(".it-slider__right__detail__controls__arrow--right");
        rightArrow?.addEventListener("click", function (){
            switchSlide(slider, 1, leftArrow, rightArrow);
        });
    });
}

function switchSlide(slider, dir, leftArrow, rightArrow){
    const contentSlides = slider.querySelectorAll(".it-slider__right__detail__content__item");
    const contentActiveClass = "it-slider__right__detail__content__item--active";

    const slideCount = contentSlides.length;

    const contentCurrActive = slider.querySelector(`.${contentActiveClass}`);
    const numCurrActive = Array.from(contentSlides).indexOf(contentCurrActive);

    if(
        !(dir === 1 && (numCurrActive === (slideCount - 1))) &&
        !(dir === -1 && (numCurrActive === 0))){

        const pagNum = slider.querySelector(".it-slider__right__detail__pag__num");

        const leftSlides = slider.querySelectorAll(".it-slider__left__img");
        const leftActiveClass = "it-slider__left__img--active";

        const rightSlides = slider.querySelectorAll(".it-slider__right__img__item");
        const rightActiveClass = "it-slider__right__img__item--active";


        contentCurrActive.classList.remove(contentActiveClass);
        slider.querySelector(`.${leftActiveClass}`).classList.remove(leftActiveClass);
        slider.querySelector(`.${rightActiveClass}`).classList.remove(rightActiveClass);

        contentSlides[numCurrActive + dir].classList.add(contentActiveClass);
        leftSlides[numCurrActive + dir].classList.add(leftActiveClass);
        rightSlides[numCurrActive + dir].classList.add(rightActiveClass);

        const tl = gsap.timeline();

        tl.to(pagNum, {
            opacity: 0,

            onComplete: () => {
                pagNum.innerHTML = `0${(numCurrActive + dir) + 1}`;
            }
        });

        tl.to(pagNum, {
            y: 0,
            opacity: 1
        });
    }


    leftArrow.disabled = true;
    rightArrow.disabled = true;

    setTimeout(() => {
        leftArrow.disabled = false;
        rightArrow.disabled = false;

        if(dir === -1 && (numCurrActive === 1)){
            leftArrow.disabled = true;

        }else if(dir === 1 && (numCurrActive === (slideCount - 2))){
            rightArrow.disabled = true;
        }
    }, 1000);
}